<script>
    export let researcher = {
        id: '',
        title: '',
        name: '',
        institute: '',
        image: null,
        websites: [],
        projects: [],
        tags: [],
    }

    import {Link} from "svelte-routing";

    import Tag from './Tag.svelte'
    import ButtonMore from './ButtonMore.svelte'
</script>

<div class="card card-researcher">
    <div class="card-content">
        <span class="card-title">{researcher.name}</span>

        <div class="card-image">
            <ButtonMore to="researchers/{researcher.id}"/>

            <Link to="researchers/{researcher.id}">
                <img src="/content/people/{researcher.id}.png" width="100" alt="{researcher.name}"/>
            </Link>
        </div>
        <br />
        {#each researcher.tags as tag}
            <Tag {tag}/>
            <br/>
        {/each}<br/>
        {researcher.institute}<br />

        {#each researcher.projects as pid}
            <div class="chip">
                <Link to="projects/{pid}">{pid}</Link>
            </div>
        {/each}
    </div>
</div>

<style>
    .card-researcher {
        min-height: 650px;
    }
</style>
